// roomform.ts ↔ game/roomform.cpp — the GAME ROOM form's shared constants +
// the GameInfo record/helpers (kidfRoom, forms.ini 1034). The canvas RoomForm
// class was removed (canvas-removal R1); the DOM lobby drives the games list
// now (dom/lobby-controller.ts, which reuses GameInfo/gameInfoDescription +
// the kn* room consts).

import { GetSpeedMultiplierString } from './gameoptions.ts';
import type { GameParams } from '../../../protocol/gamemsg.ts';

export const kidfRoom = 1034;
export const kidcJoinGame = 1001;
export const kidcNewGame = 1002;
export const kidcGameList = 1003;
export const kidcChat = 1904;
export const kidcRoomName = 1201; // shares the lobby block (forms.ini 1034 LABEL 1201)
export const kidcNoGames = 1011;

// game/roomform.h:15-16
export const knLeaveRoomHintNone = 0;
export const knLeaveRoomHintJoinGame = 1;

// game/roomform.h:23-26
export const knRoomResultDone = 0;
export const knRoomResultFail = 1;
export const knRoomResultJoin = 2;
export const knRoomResultCreated = 3;

// mpshared/messages.h:103-107 (the extended room-join results)
export const knRoomJoinResultFull = 2;
export const knRoomJoinResultNotFound = 3;
export const knRoomJoinResultWrongPassword = 4;

// mpshared/messages.h:61-65 (the extended create-game results)
export const knRoomCreateGameResultUnknownMissionPack = 2;
export const knRoomCreateGameResultUpgradeMissionPack = 3;
export const knRoomCreateGameResultRoomFull = 4;

// mpshared/mpht.h:33
export const kcPlayersMax = 4 + 1;

// game/roomform.h:41-53
export interface GameInfo {
  roomid: number;
  gameid: number;
  params: GameParams;
  minplayers: number;
  maxplayers: number;
  title: string; // char[kcbLevelTitle]
  creator: string; // char[kcbPlayerName]
  playing: boolean;
  anames: string[]; // PlayerName anames[kcPlayersMax]; cnames = anames.length
}

export const emptyGameInfo = (): GameInfo => ({
  roomid: 0,
  gameid: 0,
  params: {
    packId: 0,
    packHash: new Uint8Array(16),
    dwVersionSimulation: 0,
    tGameSpeed: 0,
    szLvlFilename: '',
    filler: new Uint8Array(3),
  },
  minplayers: 0,
  maxplayers: 0,
  title: '',
  creator: '',
  playing: false,
  anames: [],
});

// roomform.cpp:650-672 — GameInfo::GetDescription
export function gameInfoDescription(info: GameInfo): string {
  // Format if not playing: "Desert River Riches, 1.0x, 2-4 players"
  // Format if playing: "Desert River Riches"
  if (info.playing) return info.title;

  const szSpeed = GetSpeedMultiplierString(info.params.tGameSpeed);
  if (info.minplayers === info.maxplayers) {
    return `${info.title}, ${szSpeed}, ${info.minplayers} players`;
  }
  return `${info.title}, ${szSpeed}, ${info.minplayers}-${info.maxplayers} players`;
}
